// DO NOT EDIT -- generated from fs/services/dx-objects/metrics.proto

import { OrgToOrgDxObjectCopyResponse } from './copy.proto';
import * as accesscontrol from '../../shared/accesscontrol';
import * as display from '../webber/frontend/display';
import * as metrics from '../../api/metrics';
import * as pagination from '../../shared/pagination';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export namespace MetricsPublic {

  export const SetMetricEndpoint = "/grpc/dx_objects.MetricsPublic/SetMetric";
  /** Sets a metric */
  export function SetMetric(sender: (req: SetMetricRequest, endpoint: string) => Promise<SetMetricResponse>, req: SetMetricRequest): { promise: () => Promise<SetMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetMetricEndpoint),
      endpoint: SetMetricEndpoint
    };
  }

  export const MarkMetricViewedEndpoint = "/grpc/dx_objects.MetricsPublic/MarkMetricViewed";
  /** Updates the LastViewed timestamp for a metric */
  export function MarkMetricViewed(sender: (req: MarkMetricViewedRequest, endpoint: string) => Promise<{}>, req: MarkMetricViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkMetricViewedEndpoint),
      endpoint: MarkMetricViewedEndpoint
    };
  }

  export const GetAllMetricsEndpoint = "/grpc/dx_objects.MetricsPublic/GetAllMetrics";
  /** Gets all metrics */
  export function GetAllMetrics(sender: (req: GetAllMetricsRequest, endpoint: string) => Promise<GetAllMetricsResponse>, req: GetAllMetricsRequest): { promise: () => Promise<GetAllMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllMetricsEndpoint),
      endpoint: GetAllMetricsEndpoint
    };
  }

  export const GetMetricEndpoint = "/grpc/dx_objects.MetricsPublic/GetMetric";
  /** Get a specific metric at the current version. */
  export function GetMetric(sender: (req: GetMetricRequest, endpoint: string) => Promise<GetMetricResponse>, req: GetMetricRequest): { promise: () => Promise<GetMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMetricEndpoint),
      endpoint: GetMetricEndpoint
    };
  }

  export const BatchGetMetricsEndpoint = "/grpc/dx_objects.MetricsPublic/BatchGetMetrics";
  export function BatchGetMetrics(sender: (req: BatchGetMetricsRequest, endpoint: string) => Promise<BatchGetMetricsResponse>, req: BatchGetMetricsRequest): { promise: () => Promise<BatchGetMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetMetricsEndpoint),
      endpoint: BatchGetMetricsEndpoint
    };
  }

  export const StarMetricEndpoint = "/grpc/dx_objects.MetricsPublic/StarMetric";
  /** Stars/unstars a metric */
  export function StarMetric(sender: (req: StarMetricRequest, endpoint: string) => Promise<{}>, req: StarMetricRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StarMetricEndpoint),
      endpoint: StarMetricEndpoint
    };
  }

  export const ArchiveMetricEndpoint = "/grpc/dx_objects.MetricsPublic/ArchiveMetric";
  /** Archives/unarchives a metric */
  export function ArchiveMetric(sender: (req: ArchiveMetricRequest, endpoint: string) => Promise<ArchiveMetricResponse>, req: ArchiveMetricRequest): { promise: () => Promise<ArchiveMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMetricEndpoint),
      endpoint: ArchiveMetricEndpoint
    };
  }

  export const BulkArchiveMetricsEndpoint = "/grpc/dx_objects.MetricsPublic/BulkArchiveMetrics";
  export function BulkArchiveMetrics(sender: (req: BulkArchiveMetricsRequest, endpoint: string) => Promise<BulkArchiveMetricsResponse>, req: BulkArchiveMetricsRequest): { promise: () => Promise<BulkArchiveMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveMetricsEndpoint),
      endpoint: BulkArchiveMetricsEndpoint
    };
  }

  export const CreateUnnamedMetricEndpoint = "/grpc/dx_objects.MetricsPublic/CreateUnnamedMetric";
  export function CreateUnnamedMetric(sender: (req: CreateUnnamedMetricRequest, endpoint: string) => Promise<{}>, req: CreateUnnamedMetricRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUnnamedMetricEndpoint),
      endpoint: CreateUnnamedMetricEndpoint
    };
  }

  export const GetUnnamedMetricEndpoint = "/grpc/dx_objects.MetricsPublic/GetUnnamedMetric";
  export function GetUnnamedMetric(sender: (req: GetUnnamedMetricRequest, endpoint: string) => Promise<GetUnnamedMetricResponse>, req: GetUnnamedMetricRequest): { promise: () => Promise<GetUnnamedMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUnnamedMetricEndpoint),
      endpoint: GetUnnamedMetricEndpoint
    };
  }

  export const GetMetricsAccessEndpoint = "/grpc/dx_objects.MetricsPublic/GetMetricsAccess";
  export function GetMetricsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMetricsAccessEndpoint),
      endpoint: GetMetricsAccessEndpoint
    };
  }
}

/** MetricsAdmin provides administrative operations for metrics that are restricted to FullStory internal users */
export namespace MetricsAdmin {

  export const CopyMetricsToOrgEndpoint = "/grpc/dx_objects.MetricsAdmin/CopyMetricsToOrg";
  /**
   * CopyMetricsToOrg copies metrics from one org to another
   * Only accessible to FullStory internal users
   */
  export function CopyMetricsToOrg(sender: (req: CopyMetricsToOrgRequest, endpoint: string) => Promise<OrgToOrgDxObjectCopyResponse>, req: CopyMetricsToOrgRequest): { promise: () => Promise<OrgToOrgDxObjectCopyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CopyMetricsToOrgEndpoint),
      endpoint: CopyMetricsToOrgEndpoint
    };
  }
}

/**
 * MetricDetail is a seat's view of a saved metric.
 * It contains the metric definition, audit metadata,
 * and seat-level settings such as starred, last viewed timestamp, etc.
 */
export interface MetricDetail {
  metric: search_settings.MetricRecord | null;
  /** Whether the seat in the request has starred the metric. False if this is a machine caller. */
  starred: boolean;
  /** When the seat in the request last viewed the metric. Unset if this is a machine caller. */
  lastViewed: protobuf.timestamp | null;
  canned: boolean;
}

export interface SetMetricRequest {
  orgId: string;
  metric: search_settings.Metric | null;
  visibility: protoauditstore.Visibility;
}

export interface SetMetricResponse {
  metric: MetricDetail | null;
}

export interface MarkMetricViewedRequest {
  orgId: string;
  metricId: string;
}

export interface GetAllMetricsRequest {
  orgId: string;
  /** If true, archived metrics will also be returned. */
  includeArchived: boolean;
  pageInfo: pagination.PageInfoRequest | null;
}

export interface GetAllMetricsResponse {
  metrics: MetricDetail[];
  pageInfo: pagination.PageInfoResponse | null;
}

export interface GetMetricRequest {
  /** required */
  orgId: string;
  /** required */
  metricId: string;
}

export interface GetMetricResponse {
  metric: MetricDetail | null;
}

export interface BatchGetMetricsRequest {
  orgId: string;
  metricIds: string[];
}

export interface BatchGetMetricsResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found metrics will return a Result with the id supplied in the request, but a nil MetricRecord in the response.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetMetricsResponse.Result[];
}

export namespace BatchGetMetricsResponse {
  export interface Result {
    id: string;
    metric: search_settings.MetricRecord | null;
  }
}

export interface StarMetricRequest {
  orgId: string;
  metricId: string;
  /** True to star, false to unstar */
  starred: boolean;
}

export interface ArchiveMetricRequest {
  orgId: string;
  metricId: string;
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveMetricResponse {
  metric: MetricDetail | null;
}

export interface BulkArchiveMetricsRequest {
  orgId: string;
  metrics: ArchiveMetricRequest[];
}

export interface BulkArchiveMetricsResponse {
  metrics: MaybeMetricDetail[];
}

export interface MaybeMetricDetail {
  metricId: string;
  failed?: boolean;
  metric?: MetricDetail | null;
}

export namespace MaybeMetricDetail {
  export enum failed_or_metric {
    failed = 2,
    metric = 3
  }

  export function failed_or_metric_oneof(m: MaybeMetricDetail): { opt: failed_or_metric.failed, val: boolean } | { opt: failed_or_metric.metric, val: MetricDetail } | null {
    if (m.failed != null) { return { opt: failed_or_metric.failed, val: m.failed } }
    if (m.metric != null) { return { opt: failed_or_metric.metric, val: m.metric } }
    return null;
  }
}

export interface CreateUnnamedMetricRequest {
  hash: string;
  metric: UnnamedMetric | null;
  orgId: string;
}

export interface GetUnnamedMetricRequest {
  hash: string;
  orgId: string;
}

export interface GetUnnamedMetricResponse {
  hash: string;
  metric: UnnamedMetric | null;
}

export interface UnnamedMetric {
  metric?: metrics.Metric | null;
  id?: string;
  /** @deprecated */
  segmentIds: string[];
  dimensionSettings: metrics.DimensionSettings | null;
  timeRange: segment.TimeRange | null;
  timeInterval: segment.TimeInterval;
  display: display.Display | null;
  name: string;
  /** Description is set when creating a new Metric from a template which has a preconfigured description. */
  description: string;
  segments: visualizationsettings.SegmentSettings[];
  timeRangeComparison: visualizationsettings.TimeRangeComparison | null;
  singleNumberColor: visualizationsettings.Color;
}

export namespace UnnamedMetric {
  export enum metric_or_id {
    metric = 1,
    id = 2
  }

  export function metric_or_id_oneof(m: UnnamedMetric): { opt: metric_or_id.id, val: string } | { opt: metric_or_id.metric, val: metrics.Metric } | null {
    if (m.metric != null) { return { opt: metric_or_id.metric, val: m.metric } }
    if (m.id != null) { return { opt: metric_or_id.id, val: m.id } }
    return null;
  }
}

/** Request to copy metrics from one org to another */
export interface CopyMetricsToOrgRequest {
  sourceOrgId: string;
  destinationOrgId: string;
  metricIds: string[];
  /**
   * Mapping of segment IDs from source to destination
   * source_id -> destination_id
   */
  segmentMappings: { [key: string]: string };
}

/** Response containing results of metrics copy operation */
export interface CopyMetricsToOrgResponse {
  copiedMetrics: CopyMetricsToOrgResponse.CopiedMetric[];
  successCount: number;
  failureCount: number;
  failures: CopyMetricsToOrgResponse.FailedCopy[];
}

/** Response containing results of metrics copy operation */
export namespace CopyMetricsToOrgResponse {
  export interface CopiedMetric {
    sourceId: string;
    destinationId: string;
    name: string;
  }

  export interface FailedCopy {
    metricId: string;
    errorMessage: string;
  }
}
